import React from 'react'

import CardHeader from './CardHeader'
import MyPieChart from './MyPieChart'
import TooltipGraficoPizza from './TooltipGraficoPizza'

export default function GraficoTecnologias({
  portalCliente,
  handleAbrirMenuOpcoes,
  revelarOpcoesTecnologias,
  menuElement,
  graficoTotalTecnologiasIndividuais,
  graficoTotalTecnologias,
  legendaTotalTecnologias
}) {
  return (
    <div
      className="container-dashboard-fundo-1 fundo-cor-5"
      id="grafico-tecnologias"
    >
      <CardHeader
        titulo="Tecnologias"
        nomeOpcao="tecnologias"
        portalCliente={portalCliente}
        handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
      />

      <div className="grupo-dash-grafico-pizza-grande">
        {revelarOpcoesTecnologias === true && (
          <div className="menu-opcoes-dashboard-fundo">{menuElement}</div>
        )}
        <div className="container-operadoras">
          <div className="container-grafico-pizza-tecnologias">
            <div className="caixa-grafico-pizza-operadoras">
              <MyPieChart
                key={JSON.stringify(graficoTotalTecnologiasIndividuais)}
                data={graficoTotalTecnologiasIndividuais}
                valorPercentual={graficoTotalTecnologias}
                MyTooltip={(props) => (
                  <TooltipGraficoPizza
                    {...props}
                    isTecnologia
                    arrDados={graficoTotalTecnologiasIndividuais}
                    graficoTotalTecnologias={graficoTotalTecnologias}
                  />
                )}
              />
            </div>
          </div>
          <div className="container-legenda-operadoras">
            {legendaTotalTecnologias}
          </div>
        </div>
      </div>
    </div>
  )
}
